import { render, staticRenderFns } from "./BrainstormScoring.vue?vue&type=template&id=8f3bf80c&scoped=true&"
import script from "./BrainstormScoring.vue?vue&type=script&lang=js&"
export * from "./BrainstormScoring.vue?vue&type=script&lang=js&"
import style0 from "./BrainstormScoring.vue?vue&type=style&index=0&id=8f3bf80c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3bf80c",
  null
  
)

export default component.exports